export default __webpack_public_path__ + "static/media/stamp@3x.d48d2f9d.png";